type Props = boolean;

export default function setLockScreen(toggle: Props) {
  if (toggle) {
    document.getElementById("__next").style.overflowY = "hidden";
    document.getElementById("__next").style.maxHeight = "100vh";
  } else if (!toggle) {
    document.getElementById("__next").style.overflowY = "";
    document.getElementById("__next").style.maxHeight = "";
  }
}
